import { render, staticRenderFns } from "./ViewProctorTestScreen.vue?vue&type=template&id=620dd2e0"
import script from "./ViewProctorTestScreen.vue?vue&type=script&lang=js"
export * from "./ViewProctorTestScreen.vue?vue&type=script&lang=js"
import style0 from "./ViewProctorTestScreen.vue?vue&type=style&index=0&id=620dd2e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports